<template>
    <div class="content">
        <h1>SHOP</h1>
        <p>
            Die Datenübertragung im gesamten Shop-Bereich wird durch
            sichere SSL-Verschlüsselung geschützt.<br/>
            Bestellte Produkte werden ausschließlich in digitaler Form als PDF-Dateien versand.
            Dadurch werden die Umwelt geschont und Kosten gesenkt.
        </p>
        <div v-for="(item, index) in products" :key="index">
            <div :id="'ContentProduct_' + item.Id" class="content-product">
                <h2>{{ item.Name }} &nbsp;|&nbsp; {{ item.Price }} €</h2>
                <p>
                    {{ item.ShortInfo }} &nbsp;
                </p>
                <a
                    :href="previewUrl + item.Pdf"
                    title="Beispiel anzeigen"
                    target="_blank">
                <img
                    v-if="item.Id === 'H1' || item.Id === 'H2' || item.Id === 'H3'"
                    :src="previewUrl + item.Image"
                    class="item-image">
                </a>
                <div class="pos-rel">
                    <button
                        :id="'AddButton_' + index"
                        :disabled="addButtonDisabled[item.Id]"
                        class="btn btn-primary btn-to-shoppingcart"
                        @click="addItem(item.Id, item.Name, item.Price)"
                    >
                        <i class="fas fa-plus"></i>
                        In den Warenkorb legen
                    </button>
                    <div :id="'NotificationSuccess_' + item.Id" class="notification notification-success"></div>
                    <div :id="'NotificationHint_' + item.Id" class="notification notification-hint"></div>
                    <div :id="'NotificationError_' + item.Id" class="notification notification-error"></div>
                </div>
                <p class="item-description">
                    {{ item.Description }}
                </p>
                <a
                    :href="previewUrl + item.Pdf"
                    @click="emitLogData('shop', exampleLog(item.Id))"
                    target="_blank">
                    <i class="fas fa-external-link-alt"></i>
                    Beispiel anzeigen
                </a>
            </div>
        </div>
        <div class="to-shoppingcart-button">
            <div v-if="shoppingcartLength === 0">
                Es befinden sich noch keine Artikel in Ihrem Warenkorb.
            </div>
            <button
                class="btn btn-success btn-to-checkout"
                :disabled="shoppingcartLength === 0"
                @click="toShoppingcart()"
            >
                <i class="fas fa-shopping-cart"></i>
                Weiter zum Warenkorb
            </button>
        </div>
    </div>
</template>

<script>
import siteConfig from '@/assets/js/mixins/siteConfig';
import Products from '../productdata/products.json';
import JQuery from 'jquery';
let $ = JQuery;

export default {
    name: 'shop',
    mixins: [
        siteConfig
    ],
    components: {
        Products
    },
    data() {
        return {
            products: null,
            ShoppingCart: {
                Products: []
            },
            addButtonDisabled: {
                H1: false,
                H2: false,
                H3: false
            },
            addItemSuccessMessage: {
                H1: 'Die Persönlichkeits-Analyse wurde erfolgreich in den Warenkorb gelegt.',
                H2: 'Die Partnerschafts-Analyse wurde erfolgreich in den Warenkorb gelegt.',
                H3: 'Die Kinder-Analyse wurde erfolgreich in den Warenkorb gelegt.',
                G1: 'Die Geburts-Horoskopgrafik wurde erfolgreich in den Warenkorb gelegt.',
                G2: 'Die Partner-Horoskopgrafik wurde erfolgreich in den Warenkorb gelegt.',
                D1: 'Das Differenzierte Datenblatt wurde erfolgreich in den Warenkorb gelegt.',
            },
            shoppingcartLength: 0,
            toShoppingcartButtonDisabled: true,
            example: {
                H1: siteConfig.previewUrl + 'dali_karma.pdf',
                H2: siteConfig.previewUrl + 'jolie_pitt_partner.pdf',
                H3: siteConfig.previewUrl + 'grande_child.pdf'
            },
            showExample: {
                H1: false,
                H2: false,
                H3: false
            },
            previewUrl: siteConfig.previewUrl
        };
    },
    methods: {
        /**
         * method for getting shoppingcart length
         */
        getShoppingcartLength() {
            if (localStorage.shoppingcart && localStorage.shoppingcart !== '') {
                let shoppingCart = JSON.parse(localStorage.shoppingcart);
                if (shoppingCart.Products) {
                    this.shoppingcartLength = shoppingCart.Products.length;
                }
            }
        },

        /**
         * method for adding item to shoppingcart
         * ...by generating a product object to push into shoppingcart,
         * ...updating localStorage value,
         * ...updating navigation
         * ...and showing success notification
         * @param productId
         * @param name
         * @param price
         */
        addItem(productId, name, price) {
            const product = {
                ProductId: productId,
                Id: 'pcid_' + (Math.random() * 100000).toString().replace('.', '_'),
                Name: name,
                Price: price,
                Data: [{
                    FirstName: null,
                    LastName: null,
                    PlaceOfBirth: null,
                    DayOfBirth: null,
                    MonthOfBirth: null,
                    YearOfBirth: null,
                    HourOfBirth: null,
                    MinuteOfBirth: null,
                    Gender: null,
                }, {
                    FirstName: null,
                    LastName: null,
                    PlaceOfBirth: null,
                    DayOfBirth: null,
                    MonthOfBirth: null,
                    YearOfBirth: null,
                    HourOfBirth: null,
                    MinuteOfBirth: null,
                    Gender: null
                }]
            };

            if (localStorage.shoppingcart && localStorage.shoppingcart !== '') {
                this.ShoppingCart = JSON.parse(localStorage.shoppingcart);
            }

            this.ShoppingCart.Products.push(product);
            this.ShoppingCart.ProductsValid = false;

            localStorage.shoppingcart = JSON.stringify(this.ShoppingCart);

            document.getElementById('ShoppingCartLength').innerHTML = this.ShoppingCart.Products.length;
            document.getElementById('ShoppingCartLength').style = 'display: block;';

            this.getShoppingcartLength();
            this.showNotification(productId);

            this.$emit('update-shoppingcart');

            this.emitLogData('shop', 'addItemButton_' + productId);
        },

        exampleLog(productId) {
            return 'example_' + productId;
        },

        emitLogData(page, action) {
            this.$emit(
                'log-it',
                '{"page": "' + page + '", "action": "' + action + '"}'
            );
        },

        /**
         * method for displaying success notification
         * ...after adding a product to shoppingcart
         * @param productId
         */
        showNotification(productId) {
            this.addButtonDisabled[productId] = true;
            let notification = $('#NotificationSuccess_' + productId);
            notification.html(this.addItemSuccessMessage[productId]);
            notification.fadeIn('slow');
            const that = this;
            setTimeout(function() {
                that.addButtonDisabled[productId] = false;
                setTimeout(function() {
                    notification.fadeOut();
                }, 2500);
            }, 500);
        },

        /**
         * method for routing to shoppingcart page
         */
        toShoppingcart() {
            this.emitLogData('shop', 'toShoppingcartButton');
            this.$router.push({ path: 'shoppingcart' });
        }
    },
    created() {
        this.products = Products;
        this.getShoppingcartLength();
    },
    mounted() {
        this.emitLogData('shop', 'visit');
    },
    beforeDestroy() {
        this.emitLogData('shop', 'leave');
    }
};
</script>

<style lang="scss" scoped>
    .content-product {
        position: relative;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        padding: 30px 0 5px 0;
        margin: 30px 0;
    }
    .btn-to-shoppingcart {
        margin: 0;
    }
    .item-image {
        margin-bottom: 15px;
        max-width: 800px;
    }
    .item-description {
        margin: 15px 0 10px 0;
    }
    .example-container {
        margin-top: 15px;
    }
    .example-horoscope {
        width: 100%;
    }
    @media only screen and (max-width: 600px) {
        .example-container,
        .example-horoscope {
            height: 0;
        }
    }
    .to-shoppingcart-button {
        margin-top: 30px;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        padding: 35px 0 0 0;
    }
    .btn-to-checkout {
        margin-top: 10px;
    }
    .fas {
        margin-right: 6px;
    }
    .fa-external-link-alt {
        margin-right: 0;
    }
    .notification {
        bottom: 55px;
    }
</style>
